import { Candidate } from 'src/app/core/models/candidate';
import { CandidatesQueryFilter } from 'src/app/core/models/candidates-query-filter';

declare var angular: any;

export class CandidatesContainer {

  authService: any;
  divident: number;
  candidateService: any;
  alertsAndNotificationsService: any;

  candidates!: any[];
  candidatesPerPage!: any[];
  candidatesCount!: number;
  busy!: boolean;
  loadingSearchButton!: boolean;
  candidatesExistFlag!: boolean;
  candidatesQueryFilter: any;
  currentPromise: any;
  disableInfiniteScroll!: boolean;
  isFilterOn!: boolean;
  allAssignedRecruitersCount: any;

  constructor(authService: any, divident: number, candidateService: any, alertsAndNotificationsService: any) {
    this.authService = authService;
    this.divident = divident;
    this.candidateService = candidateService;
    this.alertsAndNotificationsService = alertsAndNotificationsService;

    this.$onInit();
  }

  $onInit(): void {
    this.candidates = [];
    this.candidatesPerPage = [];
    this.candidatesCount = 0;
    this.busy = false;
    this.loadingSearchButton = false;
    this.candidatesExistFlag = true;
    const userDetails = this.authService.getUserDetails();
    this.candidatesQueryFilter = new CandidatesQueryFilter(userDetails.company.companyId, userDetails.id);
    this.currentPromise = null;
    this.disableInfiniteScroll = false;
    this.isFilterOn = false;
    this.allAssignedRecruitersCount = null;
  }

  _getCandidates(successCallback: (data: any) => void, errorCallback: (error: any) => void): void {
    this.currentPromise = this.candidateService.queryCandidateIdNames(this.candidatesQueryFilter, (data: any) => {
      if (successCallback) {
        successCallback(data);
      }
    }, (error: any) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
  }

  getNext(): void {
    if (this.busy) { return; }
    this.busy = true;

    if (this.candidatesQueryFilter.pageNum === '') {
      this.candidatesQueryFilter.pageNum = 1;
    }
    this._setIsFilterOn();
    this._getCandidates((data) => {
      if (angular.isDefined(data) && data !== 'user cancellation') {
        this.candidatesCount = data.totalCandidateCount;
        if (data.candidatesNameDtos.length > 0) {
          angular.forEach(data.candidatesNameDtos, (val: any, key: number) => {
            if (key % this.divident === 0) {
              val.jobMatchesPopoverPosition = 'bottom-left';
            } else if ((key + 1) % this.divident === 0) {
              val.jobMatchesPopoverPosition = 'bottom-right';
            } else {
              val.jobMatchesPopoverPosition = 'bottom';
            }
            val.candidateIndex = (this.candidates.length + 1);
            val.jobMatchesPopoverIsOpenFlag = false;
            this.candidates.push(angular.merge(new Candidate(), val));
          });
          // if the length of the returned values is less than page size, it means there are not enough values.
          // hence we can disable the infinite scroll
          if (data.candidatesNameDtos.length < this.candidatesQueryFilter.pageSize) {
            this.disableInfiniteScroll = true;
          } else {
            this.candidatesQueryFilter.pageNum++;
          }
        } else {
          // if the length of the returned values is 0, it means there are no more values.
          // hence we can disable the infinite scroll
          this.disableInfiniteScroll = true;
        }
        // set the candidates exist flag based on existence of candidates.
        if (this.candidates.length > 0) {
          this.candidatesExistFlag = true;
        } else {
          this.candidatesExistFlag = false;
        }
      }
      this.busy = false;
      this.loadingSearchButton = false;
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
      this.busy = false;
      this.loadingSearchButton = false;
    });
  }

  getNextPage(currentPage: number): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.busy) { return; }
    this.busy = true;

    this.candidatesQueryFilter.pageNum = currentPage ? currentPage : 1;
    this._setIsFilterOn();
    this.candidatesPerPage = [];

    this._getCandidates((data) => {
      if (angular.isDefined(data) && data !== 'user cancellation') {
        this.candidatesCount = data.totalCandidateCount;
        if (data.candidatesNameDtos.length > 0) {
          angular.forEach(data.candidatesNameDtos, (val: any) => {
            val.candidateIndex = (this.candidatesPerPage.length + 1);
            val.jobMatchesPopoverIsOpenFlag = false;
            this.candidatesPerPage.push(angular.merge(new Candidate(), val));
          });
        }
        // set the candidates exist flag based on existence of candidates.
        if (this.candidatesPerPage.length > 0) {
          this.candidatesExistFlag = true;
        } else {
          this.candidatesExistFlag = false;
        }
      }
      this.busy = false;
      this.loadingSearchButton = false;
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
      this.busy = false;
      this.loadingSearchButton = false;
    });
  }

  _setIsFilterOn(): void {
    const filter = this.candidatesQueryFilter;
    if (filter.status.length > 0
      || (filter.visibility.length === 3 && this.allAssignedRecruitersCount !== null && filter.recruiterList.length === this.allAssignedRecruitersCount)
      || filter.visibility.length < 3
      || filter.roleList.length > 0
      || filter.vendors.length > 0
      || filter.requisitionNumbers.length > 0
      || filter.workflowStates.length > 0
      || (filter.workLocationIds && filter.workLocationIds.length > 0)
      || filter.searchString.length > 0
      || filter.firstName.length > 0
      || filter.lastName.length > 0
      || (filter.email !== undefined && filter.email.length > 0)
      || (filter.phone !== undefined && filter.phone.length > 0)
      || filter.clientOrBuList.length > 0
      || filter.requisitionStatus.length > 0
      || (filter.column !== undefined && filter.sortDirection !== undefined)
      || filter.recruiterList.length > 0
    ) {
      this.isFilterOn = true;
    } else {
      this.isFilterOn = false;
    }
  }
}
